import log from "loglevel";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { ContactsPage } from "@/components/pages/contacts/ContactsPage";

export default ContactsPage;

export const getStaticProps: GetStaticProps = async context => {
  try {
    return {
      props: {
        ...(await serverSideTranslations(context.locale as string, [
          "contacts",
          "common",
          "errors",
          "more-drawer"
        ]))
      }
    };
  } catch (e) {
    log.error("%0", e);

    return {
      props: {
        notFound: true
      }
    };
  }
};
